import React from "react";
import { Chip } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "../../../../components/ui/badgeColors";
import OrderStates from "../../../../utils/OrderStates";
import { COLOR_ESTADO_PEDIDO } from "../../constants";

const ETIQUETA_SIN_ESTADO = "-";

/**
 * Badge del estado de preparación de un pedido de un turno. Un estado nulo
 * se muestra en gris con '-'; uno desconocido, con su valor crudo.
 */
const EstadoPedidoBadge = ({ estado }) => {
    const sinEstado = estado === null || estado === undefined || estado === "";
    const color = sinEstado ? BADGE_COLORS.GRAY : COLOR_ESTADO_PEDIDO[estado] ?? BADGE_COLORS.GREEN;
    return (
        <Chip
            label={sinEstado ? ETIQUETA_SIN_ESTADO : OrderStates.getState(estado)}
            size="small"
            sx={getBadgeStyles(color)}
        />
    );
};

export default React.memo(EstadoPedidoBadge);
